export const OPERATION_SYSTEM = {
  MAC_OS: 'MacOS',
  WINDOWS: 'Windows',
  UNIX: 'UNIX',
  LINUX: 'Linux',
  IOS: 'IOS'
}
